import React from 'react';
import styled from 'styled-components';
import { useLocation, useParams } from 'react-router-dom';

const LandingsIframe = () => {
  const location = useLocation();
  const params = useParams();
  
  // Extract the sub-route from the current path
  // Build the path from parameters or use pathname as fallback
  let subRoute = '';
  
  if (params.path1) {
    subRoute = `/${params.path1}`;
    if (params.path2) {
      subRoute += `/${params.path2}`;
      if (params.path3) {
        subRoute += `/${params.path3}`;
      }
    }
  } else {
    // Fallback to pathname method
    subRoute = location.pathname.replace('/landings', '');
  }
  
  // If subRoute is empty, set it to '/'
  if (!subRoute || subRoute === '') {
    subRoute = '/';
  }
  
  // Construct the full URL for the iframe
  const iframeUrl = `https://sea-urchin-consulting.vercel.app${subRoute}`;

  return (
    <IframeContainer>
      <StyledIframe
        src={iframeUrl}
        title={`Landing Page - ${subRoute}`}
        frameBorder="0"
        allowFullScreen
        loading="lazy"
        allow="fullscreen"
        key={iframeUrl} // Force reload when URL changes
      />
      <LoadingMessage>
        Loading Landing Page: {subRoute === '/' ? 'Home' : subRoute}
      </LoadingMessage>
    </IframeContainer>
  );
};

const IframeContainer = styled.div`
  width: 100vw;
  height: 100vh;
  position: relative;
  overflow: hidden;
  background: #000;
`;

const StyledIframe = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  
  /* Show loading message while iframe loads */
  &:not([src]) + div {
    display: flex;
  }
`;

const LoadingMessage = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #fff;
  font-family: 'Arial', sans-serif;
  font-size: 1.2rem;
  text-align: center;
  z-index: 1;
  background: rgba(0, 0, 0, 0.8);
  padding: 2rem;
  border-radius: 10px;
  backdrop-filter: blur(5px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  
  /* Hide once iframe loads */
  ${StyledIframe}:not(:empty) ~ & {
    display: none;
  }
`;

export default LandingsIframe; 